import React from 'react';
import Highcharts from 'highcharts';
import get from 'lodash/get';

export default class ReactHighChart extends React.Component {
  constructor(props) {
    super(props);
    this.createChartInstance = this.createChartInstance.bind(this);
  }

  createChartInstance(nextProps) {
    this.chart = new Highcharts[get(this.props, 'type', 'Chart')](
      nextProps.container,
      nextProps.options
    );
  }

  componentDidMount() {
    if (get(this.props, 'modules', '')) {
      get(this.props, 'modules', '').forEach(module => {
        module(Highcharts);
      });
    }
    this.createChartInstance(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.chart.destroy();
    this.createChartInstance(nextProps);
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  render() {
    return <div id={get(this.props, 'container', '')} />;
  }
}
